import { useQuery } from "@tanstack/react-query";

import { listAudit } from "../../api/admin";
import type { AuditEntry } from "../../api/admin";
import { Button } from "../../components/Button";
import { EmptyState } from "../../components/EmptyState";
import { Skeleton } from "../../components/Skeleton";
import { nl } from "../../i18n/nl";
import { formatDateTime } from "../../lib/format";
import styles from "./moderation.module.css";
import { AUDIT_KEY } from "./queries";

const t = nl.admin.moderation;

function entryText(entry: AuditEntry): string {
  const who = entry.actor?.initials ?? t.someone;
  const what = t.auditActions[entry.action] ?? t.auditUnknown(entry.action);
  return [who, what].join(" ");
}

export function AuditList() {
  const audit = useQuery({ queryKey: AUDIT_KEY, queryFn: () => listAudit() });
  if (audit.isPending) {
    return (
      <div className={styles.skeletons} aria-hidden="true">
        <Skeleton height={48} />
        <Skeleton height={48} />
        <Skeleton height={48} />
      </div>
    );
  }
  if (audit.isError) {
    return (
      <EmptyState title={t.loadError} action={<Button onClick={() => void audit.refetch()}>{nl.common.retry}</Button>} />
    );
  }
  if (audit.data.length === 0) return <EmptyState title={t.auditEmpty} />;
  return (
    <ol className={styles.audit} aria-label={t.auditLabel}>
      {audit.data.map((entry) => (
        <li key={entry.id} className={styles.auditRow}>
          <time className={styles.auditTime} dateTime={entry.created_at}>
            {formatDateTime(entry.created_at)}
          </time>
          <span>
            {entryText(entry)}
            {entry.target_label && <span className={styles.auditTarget}> · {entry.target_label}</span>}
          </span>
        </li>
      ))}
    </ol>
  );
}
